import { IApplicationState } from 'shared/types/redux';

export const selectRedirectInfoForAuth = (state: IApplicationState) => ({
  pathForRedirect: state.landing.authorizedModal.pathForRedirect,
  typeForRedirect: state.landing.authorizedModal.typeForRedirect,
  bankName: state.landing.authorizedModal.bankName,
});
